import type { FC, ReactNode } from "react";

import style from "../PanelGroup.module.css";

export interface FlexPanelProps {
  children: ReactNode;
}

// FlexPanel component
export const FlexPanel: FC<FlexPanelProps> = ({ children }) => {
  return (
    <div className={style.pane} style={{ flex: "1 1 auto" }}>
      {children}
    </div>
  );
};
